import { useState } from 'react';
import type { ScreenProps } from '../../app/types';
import { ActionButton, Card, PrintBadge, ScrollTable } from '../../components/ui';
import { EntityLink } from '../../components/EntityLink';
import { sortActiveLots } from '../../domain/lotOrder';
import LotDetail from './LotDetail';
import LotMap from './LotMap';

type LotView = 'activos' | 'hist' | 'mapa';

export default function LotScreen(props: ScreenProps & { selectedId?: string }) {
  const { state, selectedId, openForm, navigate, canEdit } = props;
  const [view, setView] = useState<LotView>('activos');
  const lot = state.lotes.find(record => record.id === selectedId);
  if (lot) return <LotDetail {...props} lot={lot} />;
  const lots = view === 'activos' ? sortActiveLots(state) : state.lotes.filter(record => record.estado === 'finalizado');
  return <>
    <div className="section-toolbar">
      <div className="tabs-sub" aria-label="Vistas de lotes">
        {([['activos', 'Lotes activos'], ['hist', 'Historial'], ['mapa', 'Mapa físico']] as const).map(([id, label]) => <button type="button" key={id} className={view === id ? 'active' : ''} aria-pressed={view === id} onClick={() => setView(id)}>{label}</button>)}
      </div>
      <ActionButton variant="wheat" disabled={!canEdit} onClick={() => openForm('formNuevoLote')}>📦 Nuevo lote</ActionButton>
    </div>
    {selectedId && <p role="status" className="muted">El lote seleccionado ya no está disponible.</p>}
    {view === 'mapa' ? <LotMap {...props} /> : <Card>
      <h2>{view === 'activos' ? 'Lotes activos' : 'Historial de lotes'} <span className="count">{lots.length}</span></h2>
      {!lots.length ? <div className="empty-state">Sin lotes en esta vista.</div> : <ScrollTable label={view === 'activos' ? 'Lotes activos' : 'Historial de lotes'}>
        <thead><tr><th scope="col">Lote</th><th scope="col">Espacio actual</th><th scope="col">Cantidad</th><th scope="col">Estado</th></tr></thead>
        <tbody>{lots.map(record => <tr key={record.id}>
          <td><EntityLink state={state} navigate={navigate} reference={{ type: 'lote', id: record.id }}><b>{record.id}</b></EntityLink>{' '}<PrintBadge record={record} /></td>
          <td>{record.espacioActual || '—'}</td><td>{record.cantidadActual}</td><td><span className={`badge ${record.estado === 'activo' ? 'act' : 'fin'}`}>{record.estado}</span></td>
        </tr>)}</tbody>
      </ScrollTable>}
    </Card>}
  </>;
}
